import createReducer from '../../core/helpers/createReducer';
import {AUTH_ACTION_TYPES} from '../../core/constants/actionTypes';

export const authState = createReducer(false, {
  [AUTH_ACTION_TYPES.RX_SET_IS_AUTH_BOOL]: (state, action) => {
    return action.payload
  },
});
